<dashboardnav>
  
    <cradua-measure
        [measures]="measures$ | async"
        (measure)="onSubmitMeasure($event)"
        (deleteMeasureEvent)="onDeleteMeasure($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-measure>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  